import CONQUER from "../CONQUER";
import { Platform } from "../UTILS/Types";

import { v4 as UuidV4 } from 'uuid';

type Callback = Promise<{result:boolean, error?:Error}>
type ApplixirAdStatus = 'ad-initready' | 'ad-started' | 'fb-started' | 'ad-watched' | 'fb-watched' | 'ad-interrupted' | 'sys-closing' | 'cors-error' | 'network-error' | 'ad-blocker' | 'ads-unavailable' | 'no-zoneId' | undefined;

class Ads
{
    private conquer : CONQUER;
    private uuid:string;
    public loadedNetwork : Ads.AdsNetwork;
    private isInterstitialLoaded: boolean;
    private isRewardedLoaded: boolean;
    private isEventRegistered: boolean;
    private adSenseRetried: boolean;
    private adApplixirResult: 'Wait' | 'Watched' | 'Unavailable' | 'Skipped' | 'Error'; 
    private adApplixirRawResult: ApplixirAdStatus; 

    constructor( conquer:CONQUER )
    {
        this.adSenseRetried = false;
        this.adApplixirResult = 'Wait';
        this.conquer = conquer;
        this.uuid = UuidV4();
        this.isInterstitialLoaded = false;
        this.isRewardedLoaded = false;
        this.isEventRegistered = false;
        console.log(`uuid: ${this.uuid}`);
        this.loadedNetwork = 'None';
    }

    private onMessageToWebviewReceived(endpoint:string, message:string) {
        var result = JSON.parse(message);
        console.log('this', this);
        if (endpoint == `adsLoadRewarded`) {
            this.isRewardedLoaded = result;
        } else if (endpoint == `adsShowRewarded`) {
            this.isRewardedLoaded = result;
        } else if (endpoint == `adsLoadInterstitial`) {
            this.isInterstitialLoaded = result;
        } else if (endpoint == `adsShowInterstitial`) {
            this.isInterstitialLoaded = result;
        }
    }

    public async loadInterstitial():Promise<any> {
        if (typeof window == 'undefined') return Promise.resolve({result:false, error:new Error(`window is not defined`)});
        
        if (!this.isEventRegistered && typeof (window as any).onMessageToWebviewReceived != 'undefined') {
            (window as any).onMessageToWebviewReceived.push((endpoint:any, message:any) => { 
                (window as any).conquer.Ads.onMessageToWebviewReceived(endpoint, message);
            });
            (window as any).conquer.Ads.isEventRegistered = true;
        }

        if (this.isInterstitialLoaded) {
            return Promise.resolve({
                result:false, 
                error:new Error(`[ads] interstitial ads  is already loaded`)
            });
        }
        if (this.conquer.currentPlatform == 'Android') 
        {
            // HACK : prevent ads actually being called
            // this.isInterstitialLoaded = true;
            // return Promise.resolve({ result: true });

            if (typeof (window as any).adsLoadInterstitial == 'undefined') {
                return Promise.resolve({
                    result:false, 
                    error:new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
                });
            }
            let output = await (window as any).adsLoadInterstitial();
            this.isInterstitialLoaded = output.result;
            return Promise.resolve({ result: output.result, error: output.error});
        } else if (this.conquer.currentPlatform == 'Web') 
        {
            // return this.adsAdsenseLoad('Interstitial');
            return this.adsApplixirLoad('Interstitial');
        } else if (this.conquer.currentPlatform == 'iOS') 
        {
            return Promise.resolve({
                result:false, 
                error:new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
            });
        } else
        {
            return Promise.resolve({
                result:false, 
                error:new Error(`[ads] ${this.conquer.currentPlatform} is not recognized`)
            });
        }
    };

    public async showInterstitial():Promise<any> {
        if (typeof window == 'undefined') return Promise.resolve({result:false, error:new Error(`window is not defined`)});
        
        if (!this.isEventRegistered && typeof (window as any).onMessageToWebviewReceived != 'undefined') {
            (window as any).onMessageToWebviewReceived.push((endpoint:any, message:any) => { 
                var w = window as any;
                w.conquer.Ads.onMessageToWebviewReceived(endpoint, message);
            });
            (window as any).conquer.Ads.isEventRegistered = true;
        }

        if (!this.isInterstitialLoaded) {
            return Promise.resolve({
                result:false, 
                error:new Error(`[ads] interstitial ads  is not yet loaded`)
            });
        }

        if (this.conquer.currentPlatform == 'Android') 
        {
            // HACK : prevent ads actually being called
            // this.isInterstitialLoaded = false;
            // return Promise.resolve({ result: true });

            if (typeof (window as any).adsShowInterstitial == 'undefined') {
                return Promise.resolve({
                    result:false, 
                    error:new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
                });
            }
            let output = await (window as any).adsShowInterstitial();
            this.isInterstitialLoaded = !output.result;
            return Promise.resolve({ result: output.result, error: output.error});
        } else if (this.conquer.currentPlatform == 'Web') 
        {
            // return this.adsAdsenseShow('Interstitial');
            return this.adsApplixirShow('Interstitial');
        } else if (this.conquer.currentPlatform == 'iOS') 
        {
            return Promise.resolve({
                result:false, 
                error:new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
            });
        } else
        {
            return Promise.resolve({
                result:false, 
                error:new Error(`[ads] ${this.conquer.currentPlatform} is not recognized`)
            });
        }
    };

    public async loadRewarded():Promise<any> {
        if (typeof window == 'undefined') return Promise.resolve({result:false, error:new Error(`window is not defined`)});
        
        if (!this.isEventRegistered && typeof (window as any).onMessageToWebviewReceived != 'undefined') {
            (window as any).onMessageToWebviewReceived.push((endpoint:any, message:any) => { 
                var w = window as any;
                w.conquer.Ads.onMessageToWebviewReceived(endpoint, message);
            });
            (window as any).conquer.Ads.isEventRegistered = true;
        }
        
        if (this.isRewardedLoaded) {
            if (this.conquer.currentPlatform == 'Web') {
                return Promise.resolve({result:true});
            }
            return Promise.resolve({
                result:false, 
                error:new Error(`[ads] rewarded ads is already loaded`)
            });
        }
        if (this.conquer.currentPlatform == 'Android') 
        {
            
            // HACK : prevent ads actually being called
            // this.isRewardedLoaded = true;
            // return Promise.resolve({ result: true });

            if (typeof (window as any).adsLoadRewarded == 'undefined') {
                return Promise.resolve({
                    result:false, 
                    error:new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
                });
            }
            let output = await (window as any).adsLoadRewarded();
            this.isRewardedLoaded = output.result;
            return Promise.resolve({ result: output.result, error: output.error});
        } else if (this.conquer.currentPlatform == 'Web') 
        {
            // return this.adsAdsenseLoad('Rewarded');
            return this.adsApplixirLoad('Rewarded');
        } else if (this.conquer.currentPlatform == 'iOS') 
        {
            return Promise.resolve({
                result:false, 
                error:new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
            });
        } else
        {
            return Promise.resolve({
                result:false, 
                error:new Error(`[ads] ${this.conquer.currentPlatform} is not recognized`)
            });
        }
    };

    public async showRewarded():Promise<any> {
        if (typeof window == 'undefined') return Promise.resolve({result:false, error:new Error(`window is not defined`)});
        
        if (!this.isEventRegistered && typeof (window as any).onMessageToWebviewReceived != 'undefined') {
            (window as any).onMessageToWebviewReceived.push((endpoint:any, message:any) => { 
                var w = window as any;
                w.conquer.Ads.onMessageToWebviewReceived(endpoint, message);
            });
            (window as any).conquer.Ads.isEventRegistered = true;
        }
        
        if (!this.isRewardedLoaded) {
            return Promise.resolve({
                result:false, 
                error:new Error(`[ads] rewarded ads is not yet loaded`)
            });
        }

        if (this.conquer.currentPlatform == 'Android') 
        {
            
            // HACK : prevent ads actually being called
            // this.isRewardedLoaded = false;
            // return Promise.resolve({ result: true });

            if (typeof (window as any).adsShowRewarded == 'undefined') {
                return Promise.resolve({
                    result:false, 
                    error:new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
                });
            }

            let output = await (window as any).adsShowRewarded();
            this.isRewardedLoaded = !output.result;
            return Promise.resolve({ result: output.result, error: output.error});
        } else if (this.conquer.currentPlatform == 'Web') 
        {
            // return this.adsAdsenseShow('Rewarded');
            return this.adsApplixirShow('Rewarded');
        } else if (this.conquer.currentPlatform == 'iOS') 
        {
            return Promise.resolve({
                result:false, 
                error:new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
            });
        } else
        {
            return Promise.resolve({
                result:false, 
                error:new Error(`[ads] ${this.conquer.currentPlatform} is not recognized`)
            });
        }
    };

    private _adsApplixirInstance:{load:(adType:Ads.AdType) => Callback, show:(adType:Ads.AdType) => Callback} | undefined;
    public get adsApplixirInstance ():Promise<{load:(adType:Ads.AdType) => Callback, show:(adType:Ads.AdType) => Callback} | undefined> {

        return (async ():Promise<{load:(adType:Ads.AdType) => Callback, show:(adType:Ads.AdType) => Callback} | undefined> => {

            if (!this._adsApplixirInstance) {
                console.log('init applixir');
    
                await new Promise<void>((resolve, reject) =>
                {
                    var applixirIFrame      = document.createElement('iframe');
                    applixirIFrame.id       = 'applixir_parent';
                    applixirIFrame.setAttribute('allow', 'autoplay; fullscreen');
                    
                    var applixirDiv         = document.createElement('div');
                    applixirDiv.id          = 'applixir_vanishing_div';
                    applixirDiv.setAttribute('style', 'z-index: 9999;');
                    applixirDiv.hidden      = true;
                    applixirDiv.append(applixirIFrame);

                    var applixirFrameTop            = document.createElement('div');
                    applixirFrameTop.id             = 'applixir_frame_top';
                    applixirFrameTop.setAttribute('style', 'z-index:20000; position:absolute; background-color:#888; width:100%; height:calc((100% - 430px) / 2); top:0;');
                    applixirFrameTop.hidden         = true;
                    applixirFrameTop.onclick        = (event) => {
                        event.stopPropagation();
                    };

                    var applixirFrameBottom         = document.createElement('div');
                    applixirFrameBottom.id          = 'applixir_frame_bottom';
                    applixirFrameBottom.setAttribute('style', 'z-index:20000; position:absolute; background-color:#888; width:100%; height:calc((100% - 430px) / 2); bottom:-25px;');
                    applixirFrameBottom.hidden      = true;
                    applixirFrameBottom.onclick     = (event) => {
                        event.stopPropagation();
                    };

                    var applixirFrameLeft         = document.createElement('div');
                    applixirFrameLeft.id          = 'applixir_frame_left';
                    applixirFrameLeft.setAttribute('style', 'z-index:20000; position:absolute; background-color:#888; width:calc((100% - 640px) / 2); height:100%; left:-20px;');
                    applixirFrameLeft.hidden      = true;
                    applixirFrameLeft.onclick     = (event) => {
                        event.stopPropagation();
                    };

                    var applixirFrameRight         = document.createElement('div');
                    applixirFrameRight.id          = 'applixir_frame_right';
                    applixirFrameRight.setAttribute('style', 'z-index:20000; position:absolute; background-color:#888; width:calc((100% - 640px) / 2); height:100%; right:0px;');
                    applixirFrameRight.hidden      = true;
                    applixirFrameRight.onclick     = (event) => {
                        event.stopPropagation();
                    };
    
                    document.body.prepend(applixirDiv);
                    document.body.append(applixirFrameTop);
                    document.body.append(applixirFrameBottom);
                    document.body.append(applixirFrameLeft);
                    document.body.append(applixirFrameRight);
    
                    var applixirScript      = document.createElement('script');
                    applixirScript.type     = 'text/javascript';
                    applixirScript.src      = 'https://cdn.applixir.com/applixir.sdk3.0m.js';
                    applixirScript.async    = true;
                    applixirScript.defer    = true;
    
                    applixirScript.onload = () => {
                        console.log('applixir loaded!')
                        resolve();
                    }

                    console.log('applixir load...')
                    document.body.appendChild(applixirScript);
                });
    
                var zoneId:number = 2050; // test applixir's 
                // var zoneId:number = 5667; // garibaldy's
                var gameId:number = 7840; // garibaldy's
        
                var onAdStatus = (status:ApplixirAdStatus) => {
                    // This can contain whatever code you like. The err parameter will return the 
                    // following values (see online documentation for other values):
                    //	'ad-blocker' = an ad blocker was detected
                    //	'network-error' = network connection not available
                    //  'cors-error' = cross-origin error (try clearing browser cache)
                    //  'no-zoneId' = the required zoneId value is missing
                    //	'ad-watched' = an ad was presented and ran for more than 5 seconds
                    //	'ad-interrupted' = ad was ended prior to 5 seconds (abnormal end)
                    //	'ads-unavailable' = no ads were returned to the player
        
                    if (status != undefined) console.log('Applixir status: ' + status);

                    if (status == 'ad-watched' || status == 'fb-watched')
                    {
                        this.adApplixirRawResult = status;
                        this.adApplixirResult = 'Watched';
                    }
                    else if (status == 'ad-interrupted')
                    {
                        this.adApplixirRawResult = status;
                        this.adApplixirResult = 'Skipped';
                    }
                    else if (status == 'ads-unavailable')
                    {
                        this.adApplixirRawResult = status;
                        this.adApplixirResult = 'Unavailable';
                    }
                    else if (status == 'cors-error' || status == 'network-error' || status == 'ad-blocker' || status == 'no-zoneId')
                    {
                        this.adApplixirRawResult = status;
                        this.adApplixirResult = 'Error';
                    }
                    
                }

                var options = {   // see online documentation for additional informaiton
                    zoneId: zoneId, // required: the zone ID from the "Games" page
                    gameId: gameId, // optional: the ID for this game from the "Games"
                    userId: this.uuid, // required: UUID value for current customer (required for targeted ads - UUID4 recommended)
                    adStatusCb: onAdStatus, // required: callback function to provide information regarding ad status
                    // fallback: "1",
                    // verbosity: 4
                };

                var loadAd = async (adType:Ads.AdType):Callback => {
                    console.log('load ad applixir');
                    if (adType == "Interstitial") {
                        this.isInterstitialLoaded = true;
                    } else if (adType == "Rewarded") {
                        this.isRewardedLoaded = true;
                    }
                    this.adApplixirResult = 'Wait';
                    return Promise.resolve({result:true});
                };

                var showAd = async (adType:Ads.AdType):Callback => {
                    console.log('show ad applixir');

                    document.getElementById('applixir_frame_top')!.hidden = false;
                    document.getElementById('applixir_frame_bottom')!.hidden = false;
                    document.getElementById('applixir_frame_left')!.hidden = false;
                    document.getElementById('applixir_frame_right')!.hidden = false;

                    (window as any).invokeApplixirVideoUnit(options);
                    
                    await new Promise<void>((resolve, reject) => {
                        if (adType == "Interstitial") {
                            this.isInterstitialLoaded = false;
                        } else if (adType == "Rewarded") {
                            this.isRewardedLoaded = false;
                        }
                        var interval = setInterval(() => {
                            if (this.adApplixirResult != 'Wait') 
                            {
                                clearInterval(interval);
                                resolve();
                            }
                        }, 500);
                    });

                    document.getElementById('applixir_frame_top')!.hidden = true;
                    document.getElementById('applixir_frame_bottom')!.hidden = true;
                    document.getElementById('applixir_frame_left')!.hidden = true;
                    document.getElementById('applixir_frame_right')!.hidden = true;

                    if (this.adApplixirResult == 'Watched')
                    {
                        return Promise.resolve({result:true});
                    }
                    else 
                    {
                        var error = new Error(`${this.adApplixirResult} ${this.adApplixirRawResult}`);
                        return Promise.resolve({result:false, error: error});
                    }


                };
                
                this._adsApplixirInstance = {
                    load: loadAd,
                    show: showAd
                };
            }
    
            return Promise.resolve(this._adsApplixirInstance);

        })();
    }

    public async adsApplixirLoad (adType:Ads.AdType):Callback {
        let output = (await this.adsApplixirInstance);
        if (!output) return Promise.resolve({result:false, error:new Error(`adsApplixirInstance is not defined`)});
        return output!.load(adType);
    }

    public async adsApplixirShow (adType:Ads.AdType):Callback {
        let output = (await this.adsApplixirInstance);
        if (!output) return Promise.resolve({result:false, error:new Error(`adsApplixirInstance is not defined`)});
        return output!.show(adType);
    }

    private adsAdmobInstance:{load:Function, show:Function, on:Function} | undefined;
    public async adsAdmob () {
        if (typeof window == 'undefined') return Promise.resolve();

        let w = window as any;
        if (!this.adsAdmobInstance) {
            console.log('init admob');

            var adUnitId = 'ca-app-pub-3940256099942544/5224354917'; // demo google
            // var adUnitId = 'ca-app-pub-8639500763810556/5776030071'; // actual ad unit id

            this.adsAdmobInstance = new w.admob.RewardedAd({
                adUnitId: adUnitId,
            });
            
            this.adsAdmobInstance!.on('load', async (evt:any) => {
                // Once a rewarded ad is shown, it cannot be shown again.
                // Starts loading the next rewarded ad as soon as it is dismissed.
                this.loadedNetwork = 'AdMob';
                console.log('Admob loaded');
                console.log(evt);
            });
            
            this.adsAdmobInstance!.on('loadfail', async (evt:any) => {
                this.loadedNetwork = 'None';
                console.log('Admob fail to load');
                console.log(evt);
            });
            
            this.adsAdmobInstance!.on('show', async (evt:any) => {
                console.log('Admob shown');
                console.log(evt);
            });
            
            this.adsAdmobInstance!.on('showfail', async (evt:any) => {
                console.log('Admob fail to show');
                console.log(evt);
            });
            
            this.adsAdmobInstance!.on('reward', async (evt:any) => {
                console.log('Admob reward');
                console.log(evt);
            });
            
            this.adsAdmobInstance!.on('dismiss', async (evt:any) => {
                console.log('Admob dismiss');
                console.log(evt);
            });
            
            this.adsAdmobInstance!.on('impression', async (evt:any) => {
                console.log('Admob impression');
                console.log(evt);
            });
        }
        
        await this.adsAdmobInstance!.load();
    }

    private _adsAdsenseInstance:{load:(adType:Ads.AdType) => Callback, show:(adType:Ads.AdType) => Callback, isNew:boolean} | undefined;
    private get adsAdsenseInstance ():Promise<{load:(adType:Ads.AdType) => Callback, show:(adType:Ads.AdType) => Callback, isNew:boolean} | undefined> {

        return (async ():Promise<{load:(adType:Ads.AdType) => Callback, show:(adType:Ads.AdType) => Callback, isNew:boolean} | undefined> => {
            if (!this._adsAdsenseInstance) {
                console.log('[ads] init adsense 1', this._adsAdsenseInstance);
    
                var publisherId:string = "ca-pub-9296671723525300";
                // var adSlotId:string = "6925757303";
                var adSlotId:string = "7699405620";
                
                await new Promise<void>((resolve, reject) =>
                {
                    var testObj              = document.createElement('div');
                    document.body.appendChild(testObj);
    
                    setTimeout(() => {
                        resolve();
                    }, 100);
                });
                
                await new Promise<void>((resolve, reject) =>
                {
                    var adsenseObj              = document.createElement('ins');
                    adsenseObj.style.display    = 'block';
                    adsenseObj.style.width      = '728px';
                    adsenseObj.style.height     = '90px';
                    adsenseObj.className        = 'adsbygoogle';
                    adsenseObj.setAttribute('data-ad-client', publisherId); 
                    adsenseObj.setAttribute('data-ad-slot', adSlotId); 
                    adsenseObj.setAttribute('data-ad-format', 'auto'); 
                    adsenseObj.setAttribute('data-full-width-responsive', 'true'); 
                    // adsenseObj.setAttribute('data-adtest', 'on'); // indicates testing
                    document.body.appendChild(adsenseObj);
    
                    setTimeout(() => {
                        console.log('adsense obj loaded!')
                        resolve(); 
                    }, 100);
                });
                
                await new Promise<void>((resolve, reject) =>
                {
    
                    var adsenseScript      = document.createElement('script');
                    adsenseScript.type     = 'text/javascript';
                    adsenseScript.src      = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${publisherId}`;
                    adsenseScript.async    = true;
                    adsenseScript.defer    = true;
                    adsenseScript.setAttribute('crossorigin', 'anonymous');
                    adsenseScript.setAttribute('data-adbreak-test', 'on'); // indicates testing
    
                    adsenseScript.onload = () => {
                        console.log('adsense script loaded!')
                        resolve();
                    }
                    document.head.appendChild(adsenseScript);
                });
    
                await new Promise<void>((resolve, reject) =>
                {
                    (window as any).adsbygoogle = (window as any).adsbygoogle || [];
    
                    (window as any).adBreak = (window as any).adConfig = (o:any) => { (window as any).adsbygoogle.push(o); }
    
                    resolve();
                });
    
                var showAd = async (adType:Ads.AdType):Callback => {
                    console.log(`adsense show`);
                    try {
                        let output = await new Promise<{result: boolean, error?: Error | undefined}>((resolve,reject) => {
                            var adBreakOption = {
                                adBreakDone: (evt:{
                                    breakType: string,
                                    breakName: string,
                                    breakFormat: 'interstitial' | 'reward',
                                    breakStatus:  'notReady' | 'timeout' | 'error' | 'noAdPreloaded' | 'frequencyCapped' | 'ignored' | 'other' | 'dismissed' | 'viewed',
                                }) => {
                                    // console.log('adBreakDone', evt);
                                    if (adType == "Interstitial") {
                                        this.isInterstitialLoaded = false;
                                    } else if (adType == "Rewarded") {
                                        this.isRewardedLoaded = false;
                                    }
                                    if (evt.breakStatus == 'viewed')
                                    {
                                        this.adSenseRetried = false;
                                        resolve({
                                            result: evt.breakStatus == 'viewed',
                                            error: evt.breakStatus == 'viewed' ? undefined : new Error(`[ads] ads cannot be shown: ${evt.breakStatus}`) 
                                        });
                                    }
                                    if (evt.breakStatus == 'frequencyCapped' && !this.adSenseRetried)
                                    {
                                        this.adSenseRetried = true;
                                        loadAd(adType).then(()=>{
                                            showAd(adType).then(resolve);
                                        });
                                        resolve({
                                            result: evt.breakStatus == 'frequencyCapped',
                                            error: new Error(`[ads] ads cannot be shown: ${evt.breakStatus}`) 
                                        });
                                    } 
                                    else
                                    {
                                        resolve({
                                            result: evt.breakStatus == 'viewed',
                                            error: evt.breakStatus == 'viewed' ? undefined : new Error(`[ads] ads cannot be shown: ${evt.breakStatus}`) 
                                        });
                                    }
                                },
                                beforeAd: () => { 
                                    // console.log(`beforeAd`);
                                },
                                afterAd: () => { 
                                    // console.log(`afterAd`);
                                },

                            };
                            if (adType == "Interstitial") {
                                (adBreakOption as any).type = "start";
                            } else if (adType == "Rewarded") {
                                (adBreakOption as any).type = "reward";
                                (adBreakOption as any).beforeReward = (showAds:Function) => { // rewarded only
                                    // console.log(`beforeReward`);
                                    showAds();
                                };
                                (adBreakOption as any).adDismissed = () => { // rewarded only
                                    // console.log(`adDismissed`);
                                };
                                (adBreakOption as any).adViewed = () => { // rewarded only
                                    // console.log(`adViewed`);
                                };
                            }
                            (window as any).adBreak(adBreakOption);
                        });
                        return Promise.resolve(output);
                    } catch (err:any) {
                        return Promise.resolve({result:false, error:err});
                    }
                };
    
                var loadAd = async (adType:Ads.AdType):Callback => {
                    console.log(`adsense load`);
                    try {
                        if (this._adsAdsenseInstance!.isNew) {
                            await new Promise<void>((resolve,reject) => {
                                var adConfigOption = {
                                    preloadAdBreaks: 'on',
                                    onReady: (evt:any) => {
                                        // console.log('loadAdDone', evt);
                                        this.loadedNetwork = 'AdSense';
                                        resolve();
                                    }
                                };
                                (window as any).adConfig(adConfigOption);
                            });
                        } 
                        if (adType == "Interstitial") {
                            this.isInterstitialLoaded = true;
                        } else if (adType == "Rewarded") {
                            this.isRewardedLoaded = true;
                        }
                        this._adsAdsenseInstance!.isNew = false;
                        return Promise.resolve({result:true});
                    } catch (err:any) {
                        return Promise.resolve({result:false, error:err});
                    }
                };
    
                this._adsAdsenseInstance = {
                    load: loadAd,
                    show: showAd,
                    isNew: true,
                };
            };

            return Promise.resolve(this._adsAdsenseInstance);
        })();
    }

    public async adsAdsenseLoad (adType:Ads.AdType):Callback {
        let output = (await this.adsAdsenseInstance);
        if (!output) return Promise.resolve({result:false, error:new Error(`adsAdsenseInstance is not defined`)});
        return output!.load(adType);
    }

    public async adsAdsenseShow (adType:Ads.AdType):Callback {
        let output = (await this.adsAdsenseInstance);
        if (!output) return Promise.resolve({result:false, error:new Error(`adsAdsenseInstance is not defined`)});
        return output!.show(adType);
    }

    public async get ():Promise<boolean> {
        if (typeof window != 'undefined') {
            if (this.conquer.currentPlatform == 'Web') {
                if (this.loadedNetwork == 'None') {
                    await this.adsAdsenseLoad('Interstitial');
                    // await this.adsApplixir();
                }
                return Promise.resolve(this.loadedNetwork != 'None');
            } else if (this.conquer.currentPlatform == 'Android' || this.conquer.currentPlatform == 'iOS') {
                if (this.loadedNetwork == 'None') {
                    await this.adsAdmob();
                }
                return Promise.resolve(this.loadedNetwork != 'None');
            }
        }
        return Promise.resolve(false);
    };

    public async set ():Promise<boolean> {
        if (typeof window != 'undefined') {
            if (this.loadedNetwork == 'AdMob') {
                await this.adsAdmobInstance!.show();
                return Promise.resolve(true);
            } else if (this.loadedNetwork == 'AdSense') {
                // await this.adsAdsenseInstance!.show();
                return Promise.resolve(true);
            } else if (this.loadedNetwork == 'Applixir') {
                // await this.adsApplixirInstance!.show();
                return Promise.resolve(true);
            }
        }
        return Promise.resolve(false);
    }
    
}

namespace Ads {
    export type AdsNetwork = 'None' | 'Applixir' | 'AdMob' | 'AdSense';
    export type AdType = 'Interstitial' | 'Rewarded'
}

export default Ads;